export const rewards = {
    "entitled_first_month_50_off_campaign": "¡Enhorabuena! Ha ganado 50 ILS de descuento en su primer pago mensual",
    "entitled_first_month_30_off_campaign": "¡Enhorabuena! Ha ganado 30 ILS de descuento en su primer pago mensual"
};
